import React, { FC, useState } from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { Location } from '~/types';
import { cleanupFormValues } from '~/utils';
import LocationForm from './LocationForm';
import { locations } from '~/routes';
import { FormDrawer } from '~/components';
import { usePermissions } from '~/hooks';
import { useLocationsEdit } from '~/hooks/locations';

interface LocationEditProps {
  initialValues: Location;
}

const LocationEdit: FC<LocationEditProps> = (props) => {
  const { initialValues } = props;
  const [t] = useTranslation('locations');
  const dt = (key: string): string => t(`translation:${key}`);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { mutate, isLoading } = useLocationsEdit(handleClose);
  const onFinish = (values: Location) => {
    mutate({
      id: initialValues.id as string,
      body: cleanupFormValues({ ...initialValues, ...values }),
    });
  };

  const hasAccess = usePermissions('business.location.update');
  if (!hasAccess) return null;
  return (
    <>
      <Button onClick={handleOpen} type="primary">
        {dt('edit')}
      </Button>
      <FormDrawer
        name={locations}
        title={t('editLocation')}
        onClose={handleClose}
        onFinish={onFinish}
        loading={isLoading}
        visible={open}
      >
        <LocationForm name={locations} initialValues={initialValues} edit />
      </FormDrawer>
    </>
  );
};

export default LocationEdit;
